<template>
  <div :class="$style.box">
    <div
      v-for="item in circleList"
      :key="item.id"
      :class="$style.list"
      @click="handleLinkTo(item.id)"
    >
      <img :src="item.images" alt="游戏圈icon" />
      <div :class="$style.info">
        <p>{{ item.name }}</p>
        <div :class="$style.description" v-html="item.description"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { reportData } from '@/api/report';
export default {
  props: {
    plateId: {
      type: [Number, String],
      default: ''
    },
    circleList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    // 跳转游戏圈
    async handleLinkTo(id) {
      try {
        const r = await reportData({
          type: 1,
          data_type: 3, // 游戏圈板块-具体圈子
          game_circle_plate_id: this.plateId,
          circle_id: id
        })
      } catch (error) {
        console.log(error);
      }
      this.$router.push({ name: "gameCircle.home", query: { circleId: id } });
    }
  },
}
</script>

<style lang='scss' module>
.box {
  padding: 10px 8px 0px 8px;
  width: 100%;
  min-height: 64px;
  .list {
    display: flex;
    margin-bottom: 17px;
    width: 324px;
    height: 57px;
    > img {
      width: 57px;
      height: 57px;
      flex: none;
      border-radius: 12px;
    }
    .info {
      margin-left: 5px;
      width: 291px;
      height: 44px;
      > p {
        margin-top: 6px;
        font-size: 13px;
        line-height: 18px;
        font-weight: bold;
      }
      .description {
        font-size: 10px;
        font-weight: 400;
        color: rgba(159, 159, 159, 1);
        line-height: 14px;
        letter-spacing: 1px;
      }
    }
  }
}
</style>
